<style scoped="scoped" lang="scss">
._form /deep/ .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  // height: 40px;
  line-height: 40px;
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100px;
}

._formItem /deep/ .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  // height: 40px;
  line-height: 40px;
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 80px;
}

._form /deep/ .el-input__icon {
  content: '';
  height: 100%;
  width: 0;
  display: inline-block;
  vertical-align: middle;
  margin-left: -220px;
}

//._form /deep/ .el-input__icon:after {
//  content: "";
//  height: 100%;
//  width: 0;
//  display: inline-block;
//  vertical-align: middle;
//  margin-left: -170px;
//}

._form /deep/ .el-select {
  min-width: 80px;

  .el-select-dropdown {
    .el-scrollbar {
      .el-select-dropdown__wrap {
        .el-scrollbar__view {
          .el-select-dropdown__item:hover {
          }
        }
      }
    }
  }
}

._form /deep/ .custom-dropdown .el-select-dropdown {
  width: 100px !important; /* 设置下拉框的宽度 */
}

//
//._form /deep/ .el-input__icon {
//  right: 10px; /* 调整icon的位置 */
//}
</style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/equipment/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shebeiSN')">
            <el-input v-model="yt.conditions.sn"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeixinghao')">
            <el-input v-model="yt.conditions.modelCode"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeileixing')">
            <yi_dictionary_select :type="'EQUIPMENT_TYPES'" :ids.sync="yt.conditions.typeId"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('suoshukehu')">
            <!-- <yi_data_select multiple :type="'customer'" :ids.sync="yt.conditions.customerIds"></yi_data_select> -->
            <yi_cross_select multiple :component="'admin_customer_info_list'" :ids.sync="yt.conditions.customerIds"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('xunishebei')">
            <el-select v-model="yt.conditions.virtual">
              <el-option :label="$t('shi')" :value="1"></el-option>
              <el-option :label="$t('fou')" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('chuchangriqi')">
            <yi_time_input format="yyyy-MM-dd" type="daterange" :start.sync="yt.conditions.leaveFactoryDateStart" :end.sync="yt.conditions.leaveFactoryDateEnd"> </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('guishuzhujiSN')">
            <el-input v-model="yt.conditions.belongSn"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ orderBy: 'createTime desc' })">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng', null, 'w1')" type="primary">
          {{ $t('xinzeng') }}
        </el-button>
        <el-button size="mini" @click="show = !show" plain>
          {{ $t('daoru') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel()"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row, null, beforeShowDialog)">
              {{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button
              type="text"
              @click="
                scope.row.snTmp = scope.row.sn;
                yt.showEditDialog('fuzhi', scope.row);
              "
            >
              {{ $t('fuzhi') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('mubandianpeizhi', scope.row, '70%')">
              {{ $t('mubandianpeizhi') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/equipment/delete')">
              {{ $t('shanchu') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <div class="dialog-scroller" style="overflow-x: hidden;">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('shebeiSN')" required>
              <el-input v-model="yt.editObj.sn"></el-input>
            </el-form-item>
            <el-form-item :label="$t('shebeixinghao')" required>
              <yi_cross_select :component="'admin_equipment_series_series_model'" :fixShowColumns="modelColumns" :max="1" :ids.sync="yt.editObj.modelId" @getItems="setTypeId"></yi_cross_select>
            </el-form-item>
            <el-form-item :label="$t('suoshukehu')" required>
              <!-- <yi_data_select :type="'customer'" :ids.sync="yt.editObj.customerId"></yi_data_select> -->
              <yi_cross_select :max="1" :component="'admin_customer_info_list'" :ids.sync="yt.editObj.customerId"> </yi_cross_select>
            </el-form-item>

            <el-form-item :label="$t('shujumoban')" required>
              <!-- <el-input v-model="yt.editObj.templateId"></el-input> -->
              <yi_cross_select :max="1" :component="'admin_data_template_protocol_list'" :ids.sync="yt.editObj.templateId"> </yi_cross_select>
            </el-form-item>
            <el-form-item :label="$t('dongtaitu')">
              <el-input v-model="yt.editObj.imgSrcStatic"></el-input>
            </el-form-item>
            <el-form-item :label="$t('chuchangriqi')">
              <yi_time_input format="yyyy-MM-dd" type="date" :time.sync="yt.editObj.leaveFactoryDate"> </yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('guishuzhujiSN')">
              <el-input v-model="yt.editObj.belongSn"></el-input>
            </el-form-item>
            <el-form-item :label="$t('shifoujinxingBase64jiema')" required>
              <el-select v-model="yt.editObj.eventTranslatedCancel">
                <el-option :label="$t('shi')" :value="true"></el-option>
                <el-option :label="$t('fou')" :value="false"></el-option>
              </el-select>
            </el-form-item>
            <div class="_form">
              <el-form-item :label="$t('jingdu')" style="display: flex;flex-wrap: nowrap;white-space: nowrap;margin-left: 106px">
                <div style="display: flex;flex-wrap: nowrap">
                  <div style="display: flex;flex-wrap: nowrap">
                    <el-col :span="3">
                      <el-select v-model="yt.editObj.longitude" :popper-class="'custom-dropdown'" :popper-append-to-body="false">
                        <el-option :label="$t('dongjing')" :value="$t('dongjing')"></el-option>
                        <el-option :label="$t('xijing')" :value="$t('xijing')"></el-option>
                      </el-select>
                    </el-col>
                    <div class="_formItem" style="display: flex;flex-wrap: nowrap">
                      <el-input style="margin-left: 63px" v-model="yt.editObj.longitudeNum" oninput="value=value.replace(/[^-0-9.]/g , '')"></el-input>
                      <div style="margin-left: -110px">{{ $t('du') }}</div>
                    </div>
                  </div>
                  <div class="_formItem" style="display: flex;flex-wrap: nowrap">
                    <el-input style="margin-left: -145px" v-model="yt.editObj.longitudeDivide" oninput="value=value.replace(/[^-0-9.]/g , '')"></el-input>
                    <div style="margin-left: -110px">{{ $t('fen') }}</div>
                  </div>
                </div>
              </el-form-item>
              <el-form-item :label="$t('weidu1')" style="display: flex;flex-wrap: nowrap;white-space: nowrap;margin-left: 106px">
                <div style="display: flex;flex-wrap: nowrap">
                  <div style="display: flex;flex-wrap: nowrap">
                    <el-col :span="3">
                      <el-select v-model="yt.editObj.latitude" :popper-class="'custom-dropdown'" :popper-append-to-body="false">
                        <el-option :label="$t('beiwei')" :value="$t('beiwei')"></el-option>
                        <el-option :label="$t('nanwei')" :value="$t('nanwei')"></el-option>
                      </el-select>
                    </el-col>
                    <div class="_formItem" style="display: flex;flex-wrap: nowrap">
                      <el-input style="margin-left: 63px" v-model="yt.editObj.latitudeNum" oninput="value=value.replace(/[^-0-9.]/g , '')"></el-input>
                      <div style="margin-left: -110px">{{ $t('du') }}</div>
                    </div>
                  </div>
                  <div class="_formItem" style="display: flex;flex-wrap: nowrap">
                    <el-input style="margin-left: -145px" v-model="yt.editObj.latitudeDivide" oninput="value=value.replace(/[^-0-9.]/g , '')"></el-input>
                    <div style="margin-left: -110px">{{ $t('fen') }}</div>
                  </div>
                </div>
              </el-form-item>
            </div>
            <el-form-item :label="$t('shebeizhizaoshang')">
              <el-input v-model="yt.editObj.manufacturer"></el-input>
            </el-form-item>
          </el-form>
        </div>

        <template slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" @click="yt.req('POST', '/web/equipment/create', beforeAdd)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </template>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <div class="dialog-scroller" style="overflow-x: hidden;">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('shebeiSN')" class="noborder" required>
              <el-input disabled v-model="yt.editObj.sn"> </el-input>
            </el-form-item>
            <el-form-item :label="$t('shebeixinghao')" required>
              <yi_cross_select :component="'admin_equipment_series_series_model'" :fixShowColumns="modelColumns" :max="1" :ids.sync="yt.editObj.modelId" @getItems="setTypeId"></yi_cross_select>
            </el-form-item>
            <el-form-item :label="$t('suoshukehu')" required>
              <!-- <yi_data_select :type="'customer'" :ids.sync="yt.editObj.customerId"></yi_data_select> -->
              <yi_cross_select :max="1" :component="'admin_customer_info_list'" :ids.sync="yt.editObj.customerId"> </yi_cross_select>
            </el-form-item>

            <el-form-item :label="$t('shujumoban')" required>
              <!-- <el-input v-model="yt.editObj.templateId"></el-input> -->
              <yi_cross_select :max="1" :component="'admin_data_template_protocol_list'" :ids.sync="yt.editObj.templateId"> </yi_cross_select>
            </el-form-item>
            <el-form-item :label="$t('jingtaitu')">
              <el-input v-model="yt.editObj.imgSrcStatic"></el-input>
            </el-form-item>
            <el-form-item :label="$t('dongtaitu')">
              <el-input v-model="yt.editObj.imgSrcDynamic"></el-input>
            </el-form-item>
            <el-form-item :label="$t('chuchangriqi')">
              <yi_time_input format="yyyy-MM-dd" type="date" :time.sync="yt.editObj.leaveFactoryDate"> </yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('guishuzhujiSN')">
              <el-input v-model="yt.editObj.belongSn"></el-input>
            </el-form-item>
            <el-form-item :label="$t('shifoujinxingBase64jiema')" required>
              <el-select v-model="yt.editObj.eventTranslatedCancel">
                <el-option :label="$t('shi')" :value="true"></el-option>
                <el-option :label="$t('fou')" :value="false"></el-option>
              </el-select>
            </el-form-item>
            <div class="_form">
              <el-form-item :label="$t('jingdu')" style="display: flex;flex-wrap: nowrap;white-space: nowrap;margin-left: 106px">
                <div style="display: flex;flex-wrap: nowrap">
                  <div style="display: flex;flex-wrap: nowrap">
                    <el-col :span="3">
                      <el-select v-model="yt.editObj.longitude" :popper-class="'custom-dropdown'" :popper-append-to-body="false">
                        <el-option :label="$t('dongjing')" :value="$t('dongjing')"></el-option>
                        <el-option :label="$t('xijing')" :value="$t('xijing')"></el-option>
                      </el-select>
                    </el-col>
                    <div class="_formItem" style="display: flex;flex-wrap: nowrap">
                      <el-input style="margin-left: 63px" v-model="yt.editObj.longitudeNum" oninput="value=value.replace(/[^-0-9.]/g , '')"></el-input>
                      <div style="margin-left: -110px">{{ $t('du') }}</div>
                    </div>
                  </div>
                  <div class="_formItem" style="display: flex;flex-wrap: nowrap">
                    <el-input style="margin-left: -145px" v-model="yt.editObj.longitudeDivide" oninput="value=value.replace(/[^-0-9.]/g , '')"></el-input>
                    <div style="margin-left: -110px">{{ $t('fen') }}</div>
                  </div>
                </div>
              </el-form-item>
              <el-form-item :label="$t('weidu1')" style="display: flex;flex-wrap: nowrap;white-space: nowrap;margin-left: 106px">
                <div style="display: flex;flex-wrap: nowrap">
                  <div style="display: flex;flex-wrap: nowrap">
                    <el-col :span="3">
                      <el-select v-model="yt.editObj.latitude" :popper-class="'custom-dropdown'" :popper-append-to-body="false">
                        <el-option :label="$t('beiwei')" :value="$t('beiwei')"></el-option>
                        <el-option :label="$t('nanwei')" :value="$t('nanwei')"></el-option>
                      </el-select>
                    </el-col>
                    <div class="_formItem" style="display: flex;flex-wrap: nowrap">
                      <el-input style="margin-left: 63px" v-model="yt.editObj.latitudeNum" oninput="value=value.replace(/[^-0-9.]/g , '')"></el-input>
                      <div style="margin-left: -110px">{{ $t('du') }}</div>
                    </div>
                  </div>
                  <div class="_formItem" style="display: flex;flex-wrap: nowrap">
                    <el-input style="margin-left: -145px" v-model="yt.editObj.latitudeDivide" oninput="value=value.replace(/[^-0-9.]/g , '')"></el-input>
                    <div style="margin-left: -110px">{{ $t('fen') }}</div>
                  </div>
                </div>
              </el-form-item>
            </div>
            <el-form-item :label="$t('shebeizhizaoshang')">
              <el-input v-model="yt.editObj.manufacturer"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" @click="yt.req('POST', '/web/equipment/update', beforeAdd)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 复制 -->
      <template v-if="yt.editObj.action == 'fuzhi'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('yuanshebeiSN')" class="noborder">
            <el-input disabled :value="yt.editObj.snTmp"> </el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeixinghao')" class="noborder">
            <el-input disabled v-model="yt.editObj.modelCode"> </el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeiSN')" required>
            <el-input v-model="yt.editObj.sn"></el-input>
          </el-form-item>
          <el-form-item :label="$t('suoshukehu')" required>
            <yi_cross_select :max="1" :component="'admin_customer_info_list'" :ids.sync="yt.editObj.customerId"> </yi_cross_select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" @click="yt.req('POST', '/web/equipment/copy')" type="primary">{{ $t('baocun') }} </el-button>
        </span>
      </template>
      <!-- 模板点编辑弹窗 -->
      <template v-if="yt.editObj.action == 'mubandianpeizhi'">
        <div class="dialog-scroller">
          <template_point_conf :equipmentId="yt.editObj.id"></template_point_conf>
        </div>
      </template>
    </el-dialog>
    <!-- 导入excel -->
    <importExcel :show.sync="show" />
  </div>
</template>
<script type="text/javascript">
import importExcel from '@@/pages/admin/equipment/info/import_excel';
import template_point_conf from '@@/pages/admin/equipment/info/template_point_conf';

export default {
  name: 'admin_equipment_info_list',
  components: {
    importExcel,
    template_point_conf
  },
  data() {
    return {
      show: false,
      fildIds: '',
      timer: null,
      leaveFactoryDate: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
      list: [],

      modelColumns: [
        {
          label: 'shebeileixing',
          prop: 'seriesTypeId',
          type: 'dictionary',
          key: 'EQUIPMENT_TYPES',
          width: 150
        },
        {
          label: 'shebeixiliemingcheng',
          prop: 'seriesName',
          width: 130
        },
        {
          label: 'shebeixinghao',
          prop: 'code'
        }
      ],
      columns: [
        {
          label: 'shebeiSN',
          prop: 'sn'
        },
        {
          label: 'shebeixinghao',
          prop: 'model.code'
        },
        {
          label: 'shebeileixing',
          prop: 'typeId',
          type: 'dictionary',
          key: 'EQUIPMENT_TYPES',
          width: 150
        },
        {
          label: 'suoshukehu',
          prop: 'customer.name'
        },
        {
          label: 'shujumoban',
          prop: 'template.name'
        },
        {
          label: 'jingtaitu',
          prop: 'imgSrcStatic'
        },
        {
          label: 'dongtaitu',
          prop: 'imgSrcDynamic'
        },
        {
          label: 'chuchangriqi',
          prop: 'leaveFactoryDate',
          type: 'time',
          format: 'YYYY-MM-DD'
        },
        {
          label: 'guishuSN',
          prop: 'belongSn'
        },
        {
          label: 'shifouxunishebei',
          prop: 'virtual',
          type: 'bool',
          inln18: ['zhengchang', 'yincang']
        },
        {
          label: 'yingsheSN',
          prop: 'referenceEquipmentSn'
        },
        {
          label: 'jingdu',
          prop: 'longitude'
        },
        {
          label: 'weidu1',
          prop: 'latitude'
        },
        {
          label: 'shifoujinxingBase64jiema',
          prop: 'eventTranslatedCancel',
          type: 'bool',
          iln18: ['shi', 'fou'],
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          format: 'YYYY-MM-DD'
        },
        {
          label: 'shebeizhizaoshang',
          prop: 'manufacturer'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 230,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        orderBy: 'createTime desc'
      };
      this.yt.get(1);
      this.utils.event_hub.$on('ADMIN_INFO_REFRESH', () => {
        this.yt.get(1);
      });
    }, 300);
  },
  destroyed() {
    clearTimeout(this.timer);
  },
  methods: {
    // 设置设备类型ID
    setTypeId(row) {
      this.yt.editObj.typeId = row.seriesTypeId;
    },
    beforeAdd(params, url) {
      params.longitude = (params.longitude === undefined ? '' : params.longitude) + (params.longitudeNum === undefined ? '' : params.longitudeNum) + (params.longitudeNum === undefined ? '' : this.$t('du')) + (params.longitudeDivide === undefined ? '' : params.longitudeDivide) + (params.longitudeDivide === undefined ? '' : this.$t('fen'));
      params.latitude = (params.latitude === undefined ? '' : params.latitude) + (params.latitudeNum === undefined ? '' : params.latitudeNum) + (params.latitudeNum === undefined ? '' : this.$t('du')) + (params.latitudeDivide === undefined ? '' : params.latitudeDivide) + (params.latitudeDivide === undefined ? '' : this.$t('fen'));

      console.log('params', params);
      return params;
    },
    beforeShowDialog() {
      console.log('this.yt.editObj', this.yt.editObj);
      if (this.yt.editObj.latitude || this.yt.editObj.longitude) {
        if (this.yt.editObj.longitude !== '') {
          let a = this.yt.editObj.longitude;
          // 使用正则表达式匹配并截取字符串
          // const regex = /(\D+)?(\d+)?度?(\d+)?分?/;
          // const matches = a.match(regex);
          const b = a.match(/([\u4e00-\u9fa5]+)/)[0];
          const c = a.match(/(\d+(\.\d+)?)/g)[0];
          const d = a.match(/(\d+(\.\d+)?)/g)[1];
          // 提取匹配结果
          // const b = matches[1] || ''; // 东经（或空字符串）
          // const c = matches[2] || ''; // 12（或空字符串）
          // const d = matches[3] || '';
          this.$set(this.yt.editObj, 'longitude', b);
          this.$set(this.yt.editObj, 'longitudeNum', c);
          this.$set(this.yt.editObj, 'longitudeDivide', d);
        }
        if (this.yt.editObj.latitude !== '') {
          let a = this.yt.editObj.latitude;
          // const regex = /(\D+)?(\d+)?度?(\d+)?分?/;
          // const matches = a.match(regex);
          const b = a.match(/([\u4e00-\u9fa5]+)/)[0];
          const c = a.match(/(\d+(\.\d+)?)/g)[0];
          const d = a.match(/(\d+(\.\d+)?)/g)[1];
          // 提取匹配结果
          // const b = matches[1] || ''; // 东经（或空字符串）
          // const c = matches[2] || ''; // 12（或空字符串）
          // const d = matches[3] || '';
          this.$set(this.yt.editObj, 'latitude', b);
          this.$set(this.yt.editObj, 'latitudeNum', c);
          this.$set(this.yt.editObj, 'latitudeDivide', d);
        }
      }

      console.log('this.yt.editObj', this.yt.editObj);
      return this.yt.editObj;
    },
    exportExcel() {
      // delete this.yt.conditions.orderBy
      let params = this.yt.conditions;
      return this.http
        .get('/web/report/export/equipment_export?orderBy=createTime desc', {
          params
        })
        .then(res => {
          let fildId = res.data;
          return this.http
            .get('/web/report/work/get', {
              params: {
                id: fildId
              }
            })
            .then(response => {
              this.fildIds = response.data.fileId;
              console.log('response.msg1', response.data.status);
              let status = response.data.status;
              if (status == 1) {
                this.getDownload();
                this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
                this.$message.success(this.$t(response.msg));
              } else if (status == -1) {
                this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
                this.$message.success(this.$t(response.msg));
              } else if (status == 0 || null) {
                this.timer = setInterval(() => {
                  this.getDownload();
                }, 1000);
              }
            });
          // this.$message.success(this.$t(res.msg))
          // this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG')
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    getDownload() {
      console.log('this.fildIdthis.fildId', this.fildIds);
      return this.http.get('/web/customer/files/download?id=' + this.fildIds).then(res => {
        let baseUrl = res.data;
        if (res.data) {
          window.open(baseUrl);
        }
      });
    }
  }
};
</script>
